var render = function render(){
  var _vm$openedOrder, _vm$openedOrder$sales, _vm$openedOrder2, _vm$openedOrder2$cust, _vm$openedOrder3, _vm$openedOrder3$mate, _vm$openedOrder4, _vm$openedOrder4$mate, _vm$openedOrder5, _vm$openedOrder6, _vm$openedOrder6$reci, _vm$openedOrder7, _vm$openedOrder7$reci;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "id": "printDiv",
      "width": "550",
      "title": `生产订单`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('div', {
    ref: "orederContent",
    staticClass: "print-content",
    attrs: {
      "id": "printContent"
    }
  }, [_c('div', {
    staticClass: "drawer-info"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h2', {
    staticClass: "sales"
  }, [_vm._v(_vm._s((_vm$openedOrder = _vm.openedOrder) === null || _vm$openedOrder === void 0 ? void 0 : (_vm$openedOrder$sales = _vm$openedOrder.sales) === null || _vm$openedOrder$sales === void 0 ? void 0 : _vm$openedOrder$sales.abbr))]), _c('h2', [_vm._v("总量：" + _vm._s(_vm.openedOrder.volPlan) + "吨")])]), _c('div', {
    staticClass: "customer"
  }, [_vm._v(" " + _vm._s((_vm$openedOrder2 = _vm.openedOrder) === null || _vm$openedOrder2 === void 0 ? void 0 : (_vm$openedOrder2$cust = _vm$openedOrder2.customer) === null || _vm$openedOrder2$cust === void 0 ? void 0 : _vm$openedOrder2$cust.name) + " " + _vm._s((_vm$openedOrder3 = _vm.openedOrder) === null || _vm$openedOrder3 === void 0 ? void 0 : (_vm$openedOrder3$mate = _vm$openedOrder3.material) === null || _vm$openedOrder3$mate === void 0 ? void 0 : _vm$openedOrder3$mate.model) + "-" + _vm._s((_vm$openedOrder4 = _vm.openedOrder) === null || _vm$openedOrder4 === void 0 ? void 0 : (_vm$openedOrder4$mate = _vm$openedOrder4.material) === null || _vm$openedOrder4$mate === void 0 ? void 0 : _vm$openedOrder4$mate.name) + " ")]), _c('div', {
    staticClass: "material"
  }, [_vm._v(" 订单编号：" + _vm._s((_vm$openedOrder5 = _vm.openedOrder) === null || _vm$openedOrder5 === void 0 ? void 0 : _vm$openedOrder5._id) + " ")]), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', [_vm._v(" 配方：#" + _vm._s((_vm$openedOrder6 = _vm.openedOrder) === null || _vm$openedOrder6 === void 0 ? void 0 : (_vm$openedOrder6$reci = _vm$openedOrder6.recipe) === null || _vm$openedOrder6$reci === void 0 ? void 0 : _vm$openedOrder6$reci.NoId) + " " + _vm._s((_vm$openedOrder7 = _vm.openedOrder) === null || _vm$openedOrder7 === void 0 ? void 0 : (_vm$openedOrder7$reci = _vm$openedOrder7.recipe) === null || _vm$openedOrder7$reci === void 0 ? void 0 : _vm$openedOrder7$reci.name) + " ")]), _c('div', [_vm._v("需求时间：" + _vm._s(_vm.openedOrder.planArrivedAt))])])]), _c('div', {
    staticClass: "drawer-tabel"
  }, [_c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrap"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.recipeColumns,
      "data": _vm.displayRecipeDetail,
      "border": "",
      "show-summary": "",
      "summary-method": _vm.handleSummary,
      "span-method": _vm.handleSpan
    }
  })], 1)])]), _c('div', {
    staticClass: "print-order"
  }, [_c('Button', {
    directives: [{
      name: "print",
      rawName: "v-print",
      value: _vm.printObj,
      expression: "printObj"
    }],
    staticStyle: {
      "margin-right": "15px"
    },
    attrs: {
      "long": "",
      "type": "primary",
      "ghost": ""
    }
  }, [_vm._v("打印订单")]), _c('Button', {
    attrs: {
      "long": "",
      "type": "success",
      "ghost": ""
    },
    on: {
      "click": _vm.printOrder
    }
  }, [_vm._v("下载订单")])], 1), _c('SalesProdProgress', {
    ref: "SalesProdProgress",
    attrs: {
      "selectedRecipeDetail": _vm.selectedRecipeDetail,
      "currentSalesOrder": _vm.openedOrder
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }